var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01925 10.677C2.85003 10.5077 2.83592 10.2421 2.97694 10.0568L3.01925 10.0084L9.70454 3.32314C9.88915 3.13854 10.1885 3.13854 10.3731 3.32314C10.5423 3.49237 10.5564 3.75798 10.4154 3.94326L10.3731 3.99167L3.68778 10.677C3.50317 10.8616 3.20386 10.8616 3.01925 10.677Z",
    fill: "#FF5555",
    stroke: "#FF5555",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65878 4.14115C4.3977 4.14171 4.1856 3.93052 4.18504 3.66945C4.18453 3.43211 4.35902 3.23524 4.5869 3.20098L4.65674 3.19571L10.038 3.18412C10.276 3.18361 10.4732 3.3591 10.5067 3.58775L10.5117 3.65782L10.5006 9.03948C10.5 9.30056 10.2879 9.51176 10.0269 9.51122C9.78951 9.51073 9.59338 9.33541 9.56009 9.10739L9.55511 9.03752L9.56499 4.13056L4.65878 4.14115Z",
    fill: "#FF5555",
    stroke: "#FF5555",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/outgoing.d22d98a8eea1d059e3f5be85fb27e613.svg";
export { ForwardRef as ReactComponent };